import { DATE_FULL_FORMAT_FROM_TIME } from '../../../../../constants/date'
import { TableDateCell } from '../../../../Table'
import { APPLICANT_PROFILE_EMAILS_COLUMN_NAME } from '../RentalPortalApplicantProfileEmails.constants'

import { ApplicantProfileEmailsMessageCell } from './ApplicantProfileEmailsMessageCell'
import { ApplicantProfileEmailsParticipantCell } from './ApplicantProfileEmailsParticipantCell'

export function getIsApplicantProfileEmailsRowActive({ focusedRow, item }) {
  return focusedRow === item.id
}

export function renderApplicantProfileEmailsCell({ item, name, ...restProps }) {
  switch (name) {
    case APPLICANT_PROFILE_EMAILS_COLUMN_NAME.Participant:
      return (
        <ApplicantProfileEmailsParticipantCell {...restProps} item={item} />
      )

    case APPLICANT_PROFILE_EMAILS_COLUMN_NAME.SentAt:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_FULL_FORMAT_FROM_TIME}
          unread={!item.is_read}
          useTodayFormat={false}
          value={item.sent_at}
        />
      )

    default:
      return <ApplicantProfileEmailsMessageCell {...restProps} item={item} />
  }
}
